<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
// 1.引入插件
import autofit from 'autofit.js'
import { onMounted, onBeforeUnmount } from 'vue'
export default {
  name: 'App',
  data() {
    return {
      isRouterAlive: true
    }
  },
  provide() { // 提供
    return {
      reload: this.reload
    }
  },
  setup() {
    // 2.因为要操作dom,所以必须在组件渲染完毕的生命周期onMounted里面配置
    // 具体配置的选项介绍在博客最下面
    onMounted(() => {
      autofit.init({
        dh: 1080,
        dw: 1920,
        el: '#app',
        resize: true
      },
      false
      )
    })
    // 3. 如果是单个页面做自适应,需要在页面销毁后删除插件,不然可能会影响其他页面,为了保险个人建议App.vue也加上组件销毁的生命周期
    onBeforeUnmount(() => {
      autofit.off()
    })
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style>
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  min-width: 1280px;
}
#app {
  overflow: hidden;
  width: 100%;
  height: 100%;
  min-width: 1280px;
}
#nprogress .bar {
  /* background: rgba(255,98,60,0.996078) !important; */
  background: #1386FB !important;
}

.el-dialog {
  border-radius: 8px !important;
}

.el-dialog__header {
  padding: 10px 20px;
  padding-bottom: 10px;
  background-color: #e9eef2;
  border-radius: 8px 8px 0 0 !important;
}

.el-dialog__headerbtn {
  top: 15px;
}
</style>

